import { EncounterService } from '@quromedical/fhir-common';
import { flatten } from '@quromedical/utils';
import { compose, resolveConstant } from '../composer';
export const createMassageRecords = data => {
  const communicationMessages = Object.entries(data);
  const messageDays = communicationMessages.map(item => {
    const [days, message] = item;
    const range = days.split('-');

    if (range.length === 1) {
      return [{
        [range[0]]: message
      }];
    }

    const start = parseInt(range[0]);
    const end = parseInt(range[1]);
    const messageArray = [];

    for (let i = start; i <= end; i++) {
      messageArray.push({
        [i]: message
      });
    }

    return messageArray;
  });
  const result = flatten(messageDays).reduce((prev, curr) => {
    return { ...prev,
      ...curr
    };
  }, {});
  return result;
};
const communications = {
  [EncounterService.TCP]: createMassageRecords({
    '1': 'TCPWelcomeMessage',
    '7': 'TCPCollectionDay8',
    '30': 'TCPCollectionDischarge'
  }),
  [EncounterService.HospitalAtHome]: {},
  [EncounterService.Arthroplasty]: {},
  [EncounterService.HealingHands]: {},
  [EncounterService.InHospitalMonitoring]: {},
  [EncounterService.RemotePatientMonitoring]: {},
  [EncounterService.HospitalAtHomeUpgrade]: {},
  [EncounterService.SPHERE]: {}
};
const resolvers = Object.entries(communications).reduce((prev, curr) => {
  const [serviceType, messageDays] = curr;
  const day = Object.entries(messageDays);
  const ruleNames = day.map(item => {
    const [rule, message] = item;
    const ruleName = `${rule}-${serviceType}`;
    const resolver = resolveConstant({
      [rule]: message
    });
    const res = [ruleName, resolver];
    return res;
  });
  const result = Object.fromEntries(ruleNames);
  return { ...prev,
    ...result
  };
}, {});
export const getRuleName = _ref => {
  let {
    dayOfAdmission,
    admissionService
  } = _ref;
  return `${dayOfAdmission}-${admissionService}`;
};
export const getMessage = compose({
  getRuleName,
  defaultAssertions: [],
  resolvers,
  defaultResolver: resolveConstant({
    0: undefined
  })
});
//# sourceMappingURL=communication.js.map